/**
 * @file index.tsx
 *
 * @fileoverview Shows a link to an email address.
 */

export interface LinkEmailProps {
  /**
   * The email address.
   */
  email: string;
  /**
   * The text to show.
   * If not provided, the email address will be shown.
   */
  text?: string;
}

export function LinkEmail({ email, text = email }: LinkEmailProps) {
  return <a href={`mailto:${email}`}>{text}</a>;
}
